export default __webpack_public_path__ + "static/slipping-fc2883e35d66122e0c9ffa8f2e390437.png";